import { useCallback, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { AccountInfo, InteractionStatus } from "@azure/msal-browser";
import { useAppContext } from "../Context/AppContext";

function Login() {
  const { instance, accounts, inProgress } = useMsal();
  const { setObjectId } = useAppContext();

  const acquireToken = useCallback(
    async (account: AccountInfo) => {
      try {
        const response = await instance.acquireTokenSilent({
          ...loginRequest,
          account,
        });

        const token = response.accessToken;
        const { jwtDecode } = await import("jwt-decode");
        const decoded: { oid?: string } = jwtDecode(token);
        const oid = decoded.oid ?? null;
        setObjectId(oid);
        localStorage.setItem("objectId", oid ?? "");
        localStorage.setItem("access_token", token);
      } catch (error) {
        console.error("Token acquisition failed:", error);
        if (error instanceof Error && error.message.includes("interaction_required")) {
          instance.loginRedirect(loginRequest);
        }
      }
    },
    [instance, setObjectId]
  );

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      if (accounts.length > 0) {
        acquireToken(accounts[0]);
      } else {
        instance.loginRedirect(loginRequest);
      }
    }
  }, [accounts, inProgress, instance, acquireToken]);

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{ minHeight: "100vh" }}
    >
      <div className="text-center">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  );
}

export default Login;
